import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../../providers/auth.service';

const LOCAL_STORAGE_PATH = 'chargeye-development-features';

let initialValue = false;
try {
    initialValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_PATH));
} catch (e) {
    console.error(e);
}

@Injectable({
    providedIn: 'root',
})
@UntilDestroy()
/**
 * This service is used to hide features which are still under development
 */
export class DevelopmentService {
    _devFeaturesEnabled$ = new BehaviorSubject<boolean>(false);

    get enabled$() {
        return this._devFeaturesEnabled$;
    }

    constructor(private authService: AuthService) {
        this._devFeaturesEnabled$.pipe(untilDestroyed(this)).subscribe((enabled) => {
            try {
                localStorage.setItem(LOCAL_STORAGE_PATH, JSON.stringify(enabled));
            } catch (e) {
                console.error(e);
            }
        });

        this.authService.ensureLoggedIn().then(() => {
            const isSys = this.authService.getPermissions().isSystemAdmin;
            if (initialValue && isSys) {
                this.enableDevFeatures();
            } else {
                this.disableDevFeatures();
            }
        });
    }

    enableDevFeatures() {
        if (this.authService.getPermissions().isSystemAdmin) {
            this._devFeaturesEnabled$.next(true);
        } else {
            this._devFeaturesEnabled$.next(false);
        }
    }
    disableDevFeatures() {
        this._devFeaturesEnabled$.next(false);
    }

    devFeaturesEnabled$() {
        return this._devFeaturesEnabled$.asObservable();
    }
    toggle() {
        if (this.authService.getPermissions().isSystemAdmin) {
            this._devFeaturesEnabled$.next(!this._devFeaturesEnabled$.value);
        }
    }
}
